import { ColumnSort } from '@tanstack/react-table';
import { SessionDimensions, SessionsResponse, useSessions } from '@va/dashboard/api-client/sessions.api';
import { useCurrentPeriodFilter } from '@va/dashboard/util-hooks';
import { useFiltersContext } from '@va/shared/feature-filters';
import { Where } from '@va/types/filters';
import { Sorting, SortingDirection } from '@va/types/requests';

export type LatestVisitorsItemV2 = SessionsResponse<(typeof DIMENSIONS)[number]>;

type Query = {
  pagination: { page: number; pageSize: number };
  order?: ColumnSort[];
  where?: Where;
};

const DIMENSIONS = [
  'countryCode',
  'latitude',
  'longitude',
  'sessionKey',
  'visitorType',
  'sessionStartUnix',
  'companyOrgType',
  'companyOrgName',
  'browserName',
  'deviceType',
  'platform',
  'hasRecording',
  'ip',
  'unfilteredVisitCount',
  'userAgent',
  'referrerUrl',
  'cityName',
] satisfies SessionDimensions[];

export const useLatestVisitors = ({ order, ...query }: Query) => {
  return useSessions({
    trace: 'latest-visitors',
    dimensions: DIMENSIONS,
    order: sortingMapper(order),
    ...query,
  });
};

const sortingMapper = (order: ColumnSort[] | undefined) =>
  order?.map(
    (o) =>
      ({ member: o.id, direction: o.desc ? SortingDirection.Desc : SortingDirection.Asc }) as Sorting<
        (typeof DIMENSIONS)[number]
      >,
  ) ?? [];

export const usePrepareLatestVisitorsListRequests = () => {
  const { appliedFilterValues } = useFiltersContext();
  const { from, until } = useCurrentPeriodFilter();

  return { payload: appliedFilterValues, from, until };
};
